import React from 'react';
import {Button, Modal, Glyphicon, FormControl} from 'react-bootstrap';
import Parse from 'parse';
import DatePicker from 'react-bootstrap-date-picker';
import moment from "moment";

const COMPLETED = "completed";

export default class ModalClass extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            addedBy: "",
            actionId: "",
            completedComment: "",
            changingOwner: false,
            changingDate: false,
            users: null,
            deadlineString: "",
            deadlineISO: null,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.save = this.save.bind(this);
        this.changeOwner = this.changeOwner.bind(this);
        this.saveOwner = this.saveOwner.bind(this);
        this.changeDate = this.changeDate.bind(this);
        this.saveDate = this.saveDate.bind(this);
    }

    componentWillReceiveProps(props) {
        let _this = this;
        if (props.action.object !== undefined && props.action.object.get("addedBy") !== undefined) {
            props.action.object.get("addedBy").fetch().then(async result => {
                let info = await result.get("info");
                _this.setState({addedBy: info.get("name")});
                console.log("addedBy updated");
            });
        }
        this.setState({
            actionId: props.action.id,
            userId: props.action.ownerId,
            projectId: props.action.projectId,
            completedComment: props.action.completedComment,
            changingOwner: false,
            changingDate: false,
            deadlineString: props.action.deadline,
            deadlineISO: props.action.deadlineMoment && props.action.deadlineMoment.toISOString(true),
        });
        // console.log(props.action, this.state, props.action.ownerInfo && props.action.ownerInfo.id);
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    closeModal() {
        this.props.close()
    }

    save() {
        new Parse.Query("Action")
            .get(this.state.actionId)
            .then(action => {
                action.set("completedComment", this.state.completedComment);
                return action.save();
            }).then(() => {
            let actionJSON = this.props.action;
            actionJSON.completedComment = this.state.completedComment;
            this.props.close(actionJSON)
        })
    }

    changeOwner() {
        this.setState({changingOwner: !this.state.changingOwner});

        let _this = this;
        //Get users
        let Membership = Parse.Object.extend("Membership");
        let Project = Parse.Object.extend("Project");
        let project = new Project();
        project.id = this.state.projectId;
        let membershipQuery = new Parse.Query(Membership);
        membershipQuery.equalTo("project", project);
        membershipQuery.include("user");
        membershipQuery.include("user.info");

        membershipQuery.find().then((results) => {
            let users = results.map(membership => membership.get("user"));
            // console.log(results, users);
            _this.setState({users});
        });

    }

    saveOwner() {
        let User = Parse.Object.extend("User");
        let user = new User();
        user.id = this.state.userId;
        new Parse.Query("Action")
            .get(this.state.actionId)
            .then(action => {
                action.set("user", user);
                return action.save();
            }).then(() => {
            window.location.reload(true);
        })
    }

    saveDate() {
        let deadlineMoment = moment(this.state.deadlineISO);
        new Parse.Query("Action")
            .get(this.state.actionId)
            .then(action => {
                action.set("deadline", deadlineMoment.toDate());
                return action.save();
            }).then(() => {
            window.location.reload(true);
        })
    }

    changeDate() {
        this.setState({changingDate: !this.state.changingDate});
    }

    handleDateChange(value) {
        this.setState({
            deadlineISO: value,
        });
    }

    render() {

        let editable = this.props.action.ownerId === Parse.User.current().id ||
            this.props.currentRole === "APL" ||
            this.props.currentRole === "PL";

        return (
            <Modal show={this.props.show} onHide={this.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Action</Modal.Title>
                </Modal.Header>
                <table className="table table-striped">
                    <tbody>
                    <tr>
                        <th style={{width: 110}}>Owner</th>
                        <td>
                            {editable && this.state.changingOwner ? (
                                <div>
                                    {this.state.users ? (
                                        <div>
                                            <select name="userId" value={this.state.userId}
                                                    onChange={this.handleChange}>
                                                {this.state.users.map(user =>
                                                    <option value={user.id} key={user.id}>
                                                        {user.get("info").get("name")}
                                                    </option>
                                                )}
                                            </select>
                                            <Button onClick={this.changeOwner} bsSize="small"
                                                    className="pull-right">Cancel</Button>{" "}
                                            <Button onClick={this.saveOwner} bsSize="small" bsStyle="primary"
                                                    className="pull-right">Save</Button>
                                        </div>
                                    ) : (
                                        <div>Laden...</div>
                                    )}
                                </div>
                            ) : (
                                <div>
                                    <strong>{this.props.action.owner}</strong><br/>
                                    <a href={"mailto:" + this.props.action.ownerEmail}>
                                        <Glyphicon glyph="envelope"/> {this.props.action.ownerEmail}
                                    </a><br/>
                                    <a href={"tel:" + this.props.action.ownerPhone}>
                                        <Glyphicon glyph="earphone"/> {this.props.action.ownerPhone}
                                    </a>
                                    {editable && <Button onClick={this.changeOwner} bsSize="small" bsStyle="primary"
                                            className="pull-right">Edit</Button>}
                                </div>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <th>Deadline</th>
                        <th>
                            {editable && this.state.changingDate ? (
                                <div>
                                    <DatePicker id="deadline" name="deadline"
                                                showClearButton={false}
                                                value={this.state.deadlineISO}
                                                weekStartsOn={1}
                                                dateFormat="DD-MM-YYYY"
                                                showTodayButton={true}
                                                onChange={this.handleDateChange}
                                                style={{width: "160px"}}
                                    /> (dd-mm-yyyy)
                                    {/*<FormControl type="text" name="deadlineString" onChange={this.handleChange}*/}
                                    {/*value={this.state.deadlineString}/>*/}
                                    <Button onClick={this.changeDate} bsSize="small"
                                            className="pull-right">Cancel</Button>{" "}
                                    <Button onClick={this.saveDate} bsSize="small" bsStyle="primary"
                                            className="pull-right">Save</Button>
                                </div>
                            ) : (
                                <div>
                                    {this.props.action.deadline}
                                    {editable && <Button onClick={this.changeDate} bsSize="small" bsStyle="primary"
                                            className="pull-right">Edit</Button>}
                                </div>
                            )}
                        </th>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <th>{this.props.action.status}</th>
                    </tr>
                    <tr>
                        <th>Added by</th>
                        <td>{this.state.addedBy}</td>
                    </tr>
                    <tr>
                        <th>Added on</th>
                        <td>{this.props.action.createdAt}</td>
                    </tr>
                    <tr>
                        <th>Description</th>
                        <td>{this.props.action.description}</td>
                    </tr>
                    {this.props.action.showCompletedAt && (
                        <tr>
                            <th>Completed on</th>
                            <td>{this.props.action.completedAt}</td>
                        </tr>
                    )}
                    {this.props.action.status === COMPLETED && (
                        <tr>
                            <th>Comment</th>
                            <td>
                                <FormControl
                                    type="text"
                                    componentClass="textarea"
                                    rows="3"
                                    name="completedComment"
                                    value={this.state.completedComment}
                                    placeholder="Comment"
                                    onChange={this.handleChange}
                                />
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>

                <Modal.Footer>
                    <Button onClick={this.closeModal}>Cancel</Button>

                    {this.props.action.status === COMPLETED && (
                        <Button onClick={this.save} bsStyle="primary">Save</Button>
                    )}
                </Modal.Footer>
            </Modal>

        );
    }

};


// WEBPACK FOOTER //
// ./src/modalAction.js